/**
 * @module components/XAxisSetting
 * @description X 轴配置卡片入口（ConfigCard 容器，子配置项独立文件维护）
 *
 * 状态管理模式：与 LegendSetting 一致，子组件各自读写 Context
 * 显隐模式：整卡由 Panel Config A visible 控制；子项由 visibleItems 控制
 *
 * 子模块：
 *   - XAxisName             X 轴名称（仅条形图）
 *   - XAxisTopN             TopN（饼图；柱状/堆叠/百分比堆叠/折线需分类维度 > 1）
 *   - XAxisSortBy           排序方式（对齐 SeriesSortBy）
 *   - XAxisLabelDirection   X 轴标签方向（柱状/堆叠/折线/组合/事件折线）
 */

import React from 'react';
import { useIntl } from 'umi';
import ConfigCollapseCard from '@/pages/datalab/components/ConfigCollapseCard';
import XAxisName from './XAxisName';
import XAxisSortBy from './XAxisSortBy';
import XAxisTopN from './XAxisTopN';
import XAxisLabelDirection from './XAxisLabelDirection';
import xAxis from '@/pages/datalab/assets/svg/x-Axis.svg';
import './index.scss';

interface IXAxisSettingProps {
  /** 子项显隐表 — 由 Panel 层根据 Config A + QB 计算后传入 */
  visibleItems?: Record<string, boolean>;
}

/**
 * XAxisSetting — X 轴配置分类组件
 *
 * 内含 X 轴名称、TopN、排序方式、轴标签方向（子项由 visibleItems 控制）
 */
const XAxisSetting: React.FC<IXAxisSettingProps> = ({ visibleItems }) => {
  const { formatMessage } = useIntl();
  const showAxisName = visibleItems?.XAxisName === true;
  const showTopN = visibleItems?.TopN === true;
  const showSortBy =
    visibleItems?.SortBy === true ||
    visibleItems?.MetricSort === true ||
    visibleItems?.ManualSort === true ||
    visibleItems?.DatasetFieldSort === true;
  const showLabelDirection = visibleItems?.XAxisLabelDirection === true;

  return (
    <ConfigCollapseCard
      className="dbl-x-axis-setting"
      title={(<>
        <img src={xAxis} alt="" style={{ marginRight: 5 }} />
        {formatMessage({ id: 'dbl_chart_x_axis' })}
      </>)}
    >
      {showAxisName && <XAxisName />}
      {showTopN && <XAxisTopN />}
      {showSortBy && <XAxisSortBy visibleItems={visibleItems} />}
      {showLabelDirection && <XAxisLabelDirection />}
    </ConfigCollapseCard>
  );
};

export default React.memo(XAxisSetting);
